import React, {useState} from "react";
import 'react-calendar/dist/Calendar.css';
import PatientEditProfile from "./PatientEditProfile";
import PatientViewProfile from "./PatientViewProfile";
import PatientInfo from "./PatientInfo";

function PatientProfile() {

	const [showInfo,setShowInfo] = useState(false)
	const [editInfo,setEditInfo] = useState(false)

	const handleView = (data) => {
		setShowInfo(data);
	};

	const handleEdit = (data) => {
		setEditInfo(data);
	};

	if (showInfo){
		return <PatientViewProfile viewInfo={handleView}/>
	}else if(editInfo){
		return <PatientEditProfile edit={handleEdit}/>
	}else{
		return <PatientInfo viewInfo={handleView} edit={handleEdit}/>
	}
}

export default PatientProfile;
